import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import ExpressionSeries from './ExpressionSeries.js';
import CurrentChord from './CurrentChord.js';
import ChordProgression from './ChordProgression.js';
import {connect} from 'react-redux';
import TidalString from './TidalString.js';

const ChordChooser = ({effect, position, currentChord}) => { 
    let progression = effect.chordProgression;
    let possibilities = effect.getPossibleNextChords().map(
        x => progression.getChord(x));
    let chord = progression.getChord(currentChord);
    let [chosen, setChosen] = useState(progression.getNextChordEffect(currentChord, position));

    useEffect(() => {
        let nextChord = progression.getNextChordEffect(currentChord, position);
        setChosen(nextChord);
    }, [currentChord, position, possibilities, setChosen]);
    
    const chooseNext = useCallback((next) => {
        chord.nextChords[position] = next;
        setChosen(next);
    }, [chord, position, setChosen]);

    return (
        <div
          draggable="true"
          onDragStart={(e) => e.preventDefault()}
          className="chord-chooser">
          <ChordProgression
            position={position}
            effect={effect}
            currentChord={currentChord}
            chosen={chosen}/>
          <CurrentChord effect={effect} chord={chord}/>
          <div className="possibilities">
            <div className="possibility-label">Next Chord: </div>
            {possibilities.map(
                x =>
                    <PossibleNext
                      isSelected={chosen === x}
                      onClick={() => chooseNext(x)} currentChord={chord} possibleChord={x}/>)}
          </div>
          <EffectParameterSlider
            parameter={effect.progressionLengthParameter}
            min={1}
            max={16}
            step={1}
            name="Length"
            isParameter={true}
            lfoEnabled={true}
            sequencerEngine={effect.track.sequencerEngine}
          />
          <EffectParameterSlider
            parameter={effect.chordProgression.progressionStartParameter}
            min={1}
            max={7}
            step={1}
            name="Start"
            isParameter={true}
            lfoEnabled={true}
            sequencerEngine={effect.track.sequencerEngine}
          />
          {/*
          <ExpressionSeries effect={effect}/>
          <TidalString effect={effect}/>
           */}
        </div>
    );
};

const PossibleNext = ({onClick, currentChord, isSelected, possibleChord}) => {
    let className = "possible-next";
    if (isSelected) {
        className += " selected";
    }
    return (
        <div
          onClick={onClick}
          className={className}>
          {possibleChord.prettyName}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      position: props.effect.position,
      currentChord: props.effect.currentChord
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChordChooser);
